// extracted by mini-css-extract-plugin
export default {"container":"contentTerAct_container__-zS98","noSidebar":"contentTerAct_noSidebar__Ev+ds"};